import React, { createContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getPlanesCuidadoResults } from "../services/api";
import { extractPatientIdFromUrl } from "../utils/helpers";
import { getPlans } from "../services/dim";

const PlanCuidadoContext = createContext();

const PlanCuidadoContextProvider = ({ children }) => {
  const [planesCuidadoData, setPlanesCuidadoData] = useState(null);
  const patientId = extractPatientIdFromUrl();
  const [listado, setListado] = useState([]);

  useEffect(() => {
    const fetchPlanesCuidadoData = async () => {
      try {
        const data = await getPlanesCuidadoResults(patientId);
        setPlanesCuidadoData(data);

        const opciones = await getPlans();
        setListado(opciones);
      } catch (error) {
        console.error(error);
      }
    };

    fetchPlanesCuidadoData();
  }, []);

  const updatePlanesCuidadoData = async () => {
    try {
      const data = await getPlanesCuidadoResults(patientId);
      setPlanesCuidadoData(data);

      const opciones = await getPlans();
      setListado(opciones);
    } catch (error) {
      console.error(error);
    }
  };


  const planesCuidadoOpciones =
    (planesCuidadoData &&
      planesCuidadoData.map((plan) => ({
        value: plan.id,
        label: plan.tipo,
      }))) ||
    [];

  const contextValue = {
    planesCuidadoData,
    updatePlanesCuidadoData,
    planesCuidadoOpciones,
    listado
  };

  return (
    <PlanCuidadoContext.Provider value={contextValue}>
      {children}
    </PlanCuidadoContext.Provider>
  );
};

PlanCuidadoContextProvider.propTypes = {
  children: PropTypes.node,
};

export { PlanCuidadoContext, PlanCuidadoContextProvider };
